import { faro, MetaUser } from '@grafana/faro-web-sdk';
import { getClientAddress, getCookie } from 'common-utils';

export const useFaroSetUser = () => {
  const retryIfFaroNotInitialized = (user?: MetaUser) => {
    let attempts = 0;
    const maxAttempts = 20; // Increased to 20 attempts (20 seconds total)
    const retryInterval = 1000; // 1 second intervals to match faro listener

    const intervalId = setInterval(() => {
      if (faro?.api) {
        const clientAddress = getClientAddress();
        const bigIntId = getCookie('__ivc');
        user &&
          (user.attributes = {
            ...user?.attributes,
            ip: clientAddress?.ip,
            bigIntId,
          });
        faro.api.setUser(user);
        clearInterval(intervalId); // Clear the interval once faro.api is ready
      } else {
        attempts++;
        if (attempts >= maxAttempts) {
          clearInterval(intervalId);
          // Only warn instead of error, and don't throw - this is not critical
          // This can happen in environments where Faro doesn't initialize (CSP restrictions, etc.)
          console.warn(
            `Faro RUM: Unable to set user - Faro is not initialized after ${maxAttempts} seconds. User tracking will be skipped.`,
          );
        }
      }
    }, retryInterval);
  };
  const setUser = (user?: MetaUser) => {
    if (faro?.api) {
      const clientAddress = getClientAddress();
      const bigIntId = getCookie('__ivc');
      user &&
        (user.attributes = {
          ...user?.attributes,
          ip: clientAddress?.ip,
          bigIntId,
        });
      faro.api.setUser(user);
    } else {
      retryIfFaroNotInitialized(user);
    }
  };
  return {
    setUser,
  };
};
